module.exports = __webpack_public_path__ + "static/media/fundacion-40.b17052de.png";